<template>
  <div class="app-body">
    <div class="activity-bg">
      <!-- <div class="activity-overlay"></div> -->
      <div class="sunburst">
        <div class="outer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="activity-signup">
        <van-cell-group>
          <van-cell>
            <div class="activity-title">四川科技小记者 - 预约报名信息</div>
          </van-cell>
        </van-cell-group>
        <van-cell-group v-if="!data.id">
          <van-cell>
            <div>对不起，未查询到您的预约报名信息，点击下方【立即预约】按钮可立即预约报名！</div>
          </van-cell>
        </van-cell-group>
        <van-cell-group v-if="data.id">
          <van-field
            v-model="data.name"
            readonly
            label="姓名"
          />
          <van-field
            v-model="data.mobile"
            readonly
            label="电话"
          />
          <van-field
            v-model="data.school"
            readonly
            label="学校"
          />
          <van-field
            v-model="data.age"
            readonly
            label="年龄"
          />
        </van-cell-group>
        <van-button v-if="!data.id" color="#ff6600" block to="/activity/signup">立即预约</van-button>
        <van-button block to="/">返回首页</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  data() {
    return {
      isLoading: false,
      data: {
        id: '',
        name:'',
        age:'',
        school: '',
        mobile: ''
      },
    }
  },
  computed: {
    bgStyle() {
      let img = this.data.activitybg ? (rootPath + this.data.activitybg) : (this.assetsPath + 'static/images/activity-bg.jpg');
      return {'background-image':`url(${img})`};
    },
  },
  activated() {
    this.doLoad();
  },
  methods: {
    doLoad() {
      if (!this.member.id) {
        this.doLogin();
        return;
      }
      this.doGet({
        url: 'vue/home/getReporter',
        okcb: (json) => {
          this.data = Object.assign({}, this.data, json || {});
        },
        cb: () => {

        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  max-height:100vh;
  overflow:hidden;
}
.activity {
  &-bg {
    position:relative;
    height:100vh;
    background-size:cover;
    background-repeat:no-repeat;
  }
  &-overlay {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    .bg-black(.65);
  }
  &-title {
    text-align:center;
    .fontsize(1.1rem);
    color:@bluecolor;
  }
  &-signup {
    position:absolute;
    left:50%;
    top:50%;
    z-index:2;
    padding:1rem;
    width:70%;
    transform:translate(-50%, -50%);
    .van-button {
      margin-top:1rem;
      .fontsize(1.1rem);
      &:first-child {
        margin-top:0;
      }
    }
  }
}
/* Sunburst
-------------------------------------------------- */

.sunburst {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
}
.sunburst .outer {
    background: #33869D;
    width: 4000px;
    height: 1820px;
    padding-top: 2180px;
    margin: -2000px 0 0 -2000px;
    animation-name: rotate1;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
.sunburst span {
    border-width: 180px 2000px;
    margin: -360px 0 0 0;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent rgba(255, 255, 255, 0.1);
    border-style: solid;
}
.sunburst span:nth-child(1) {
    transform: rotate(20deg);
    -moz-transform: rotate(20deg);
}
.sunburst span:nth-child(2) {
    transform: rotate(40deg);
    -moz-transform: rotate(40deg);
}
.sunburst span:nth-child(3) {
    transform: rotate(60deg);
    -moz-transform: rotate(60deg);
}
.sunburst span:nth-child(4) {
    transform: rotate(80deg);
    -moz-transform: rotate(80deg);
}
.sunburst span:nth-child(5) {
    transform: rotate(100deg);
    -moz-transform: rotate(100deg);
}
.sunburst span:nth-child(6) {
    transform: rotate(120deg);
    -moz-transform: rotate(120deg);
}
.sunburst span:nth-child(7) {
    transform: rotate(140deg);
    -moz-transform: rotate(140deg);
}
.sunburst span:nth-child(8) {
    transform: rotate(160deg);
    -moz-transform: rotate(160deg);
}
.sunburst span:nth-child(9) {
    transform: rotate(180deg);
    -moz-transform: rotate(180deg);
}
@keyframes rotate1 {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(20deg);
    }
}
@-moz-keyframes rotate1 {
    from {
        -moz-transform: rotate(0deg);
    }
    to {
        -moz-transform: rotate(20deg);
    }
}
</style>